<template>
  <main>
    <b-row>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/penjualan')" icon="ShoppingCartIcon" color="primary" :statistic="cardPenjualan" statistic-title="Total Penjualan" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/collection')" icon="CreditCardIcon" color="success" :statistic="cardCollection" statistic-title="Collection" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/barang')" icon="ArchiveIcon" color="warning" :statistic="cardBarang" statistic-title="Barang" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/kendaraan-barang')" icon="BoxIcon" color="danger" :statistic="cardStokBarang" statistic-title="Stok Barang (Mobil)" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/kendaraan')" icon="TruckIcon" color="primary" :statistic="cardKendaraan" statistic-title="Total Kendaraan" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/karyawan')" icon="UsersIcon" color="success" :statistic="cardKaryawan" statistic-title="Total Karyawan" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/asset-penyimpanan')" icon="BarChart2Icon" color="primary" :statistic="cardNilaiAsset" statistic-title="Nilai Aset" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/rank-sales')" icon="BarChart2Icon" color="danger" :statistic="cardSales" statistic-title="Rank Sales" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/kas')" icon="BarChart2Icon" color="danger" :statistic="cardKas" statistic-title="Total Kas" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/hutang-perusahaan')" icon="BarChart2Icon" color="danger" :statistic="`Rp ${formatRupiah(cardCompanyDebt)}`" statistic-title="Total Utang" />
      </b-col>
      <b-col cols="12"> <sales-graphic /> </b-col>
      <br />
      <br />
      <b-col cols="12">
        <profit-and-loss-graphic />
      </b-col>
      <br />
      <br />
      <b-col cols="12">
        <goods-sales-graphic />
      </b-col>
      <br />
      <br />
    </b-row>
  </main>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import { BTabs, BTab, BRow, BCol, BCard } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import SalesGraphic from './_penjualan.vue'
import ProfitAndLossGraphic from './_profit_and_loss.vue'
import GoodsSalesGraphic from './_goods_sales.vue'
export default {
  data() {
    return {
      dataPenjualan: {},
      card: {},
      dataLabaRugi: {},
      cardCompanyDebt: 0
    };
  },
  components: {
    GoodsSalesGraphic,
    SalesGraphic,
    ProfitAndLossGraphic,
    StatisticCardHorizontal,
    BAlert,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
    cardPenjualan() {
      return "Rp " + this.formatRupiah(this.card.penjualan);
    },
    cardStokBarang() {
      return "Rp " + this.formatRupiah(this.card.barangMobilNilai);
    },
    cardSales() {
      return this.card.sales + " Orang";
    },
    cardKas() {
      return this.card.totalKas ? `Rp ${this.formatRupiah( this.card.totalKas )}` : 0
    },
    cardCollection() {
      return "Rp " + this.formatRupiah(this.card.collection);
    },
    cardKeuntungan() {
      return "Rp " + this.formatRupiah(this.card.keuntungan);
    },
    cardNilaiAsset() {
      return "Rp " + this.formatRupiah(this.card.assetNilai)
    },
    cardKendaraan() {
      return this.card.kendaraan ? this.card.kendaraan + " Unit" : "0 Unit";
    },
    cardBarang() {
      return this.card.kendaraan ? this.formatRupiah(this.card.barangTotal) + " Item" : "0 Item";
    },
    cardKaryawan() {
      return this.card.karyawan + " Orang";
    },
  },
  methods: {
    async getCompanyDebt() {
      const result = await this.$store.dispatch('dashboard/checkCompanyDebt')
      if(result.totalHutang) {
        this.cardCompanyDebt = result.totalHutang
      }
    },
    postCardInfo() {
      let payload = {
        show: {
          penjualan: true,
          sales: true,
          karyawan: true,
          collection: true,
          barangTotal: true,
          kendaraan: true,
          assetTotal: true,
          assetNilai: true,
          barangMobilNilai: true,
          keuntungan: true,
          kas: true
        },
      };

      this.$store
        .dispatch("dashboard/cardInfo", payload)
        .then((res) => {
          this.card = res;
        })
        .catch((e) => console.error(e));
    },
  },

  mounted() {
    this.getCompanyDebt()
    this.postCardInfo();
  },
};
</script>
